import $ from "jquery";
import Breakpoint from 'Utils/breakpoint-dispatcher';
import { marker } from "./marker";
import { onElementBoundsOut } from "./onElementOut";
import { MainSearchAuth } from "../../components/search-field/mainSearch";
import { stickyModule } from "./stickyModule";

export default class HeaderAuth {
  constructor($el) {
  this.root = $el;
    this.authState = "AUTH";
    this.header = $(".js-header-auth");
    this.menuBarItems = this.root.find(".js-menu_item");
    this.subMenuBarItems = this.root.find(".js-submenu_item.js-outside-dropdown");

    //this.subMenuBarSubItems = this.subMenuBarItems.find(".js-submenu_elt-not-in-dropdown");
    this.subMenuBarInDropItems = this.root.find(".js-submenu_item.js-submenu_elt-in-dropdown");

    this.SCROLL_STICKY_BASE = 230;
    this.INITIAL_MARKER_POS = 2000;
    this.INITIAL_2NDMARKER_POS = 0;
    this.INITIAL_3RDMARKER_POS = 0;
    this.INITIAL_3RDMARKER_POS_HIDE = 2000;

    this.initialActiveEntry = this.getInitialEntry();
    this.secondActive = this.getSecondEntry();
    this.thirdActive = this.getThirdEntry();

    this.lastActive = this.initialActiveEntry;

    [this.marker, this.secondMarker, this.thirdMarker] = this.createMarkers();

    if (this.initialActiveEntry) {
      this.marker.updateLastElementMarked(this.initialActiveEntry);

      this.marker.replayTranslate();
    }

    this.queryActiveSubList = this.root.find(".is-active .dcw_submenu-auth_list");
    this.queryActiveDropDownList = this.root.find(".is-active .dcw_dropdown_list");
    this.queryActiveSubMenu = this.root.find(".is-active .dcw_submenu-auth");

      if (this.queryActiveSubList.length > 0) {
          if (this.queryActiveSubList instanceof $) {
              this.activeSubList = this.queryActiveSubList[0];
          } else {
              this.activeSubList = this.queryActiveSubList;
          }
      }

      if (this.queryActiveDropDownList.length > 0) {
          if (this.queryActiveDropDownList instanceof $) {
              this.activeDropDownList = this.queryActiveDropDownList[0];
          } else {
              this.activeDropDownList = this.queryActiveDropDownList;
          }
      }

      if (this.queryActiveSubMenu.length > 0) {
          if (this.queryActiveSubMenu instanceof $) {
              this.activeSubMenu = this.queryActiveSubMenu[0];
          } else {
              this.activeSubMenu = this.queryActiveSubMenu;
          }
      }

    if (this.secondActive) {
      this.secondMarker.updateLastElementMarked(this.secondActive);

      setTimeout(() => {
        this.secondMarker.replayTranslate(true, this.INITIAL_2NDMARKER_POS);
      }, 300);
    }

    if (this.thirdActive) {
          this.thirdMarker.updateLastElementMarked(this.thirdActive);

          setTimeout(() => {
              this.thirdMarker.replayTranslate(true, this.INITIAL_3RDMARKER_POS);
      }, 300);
      }

    this.handleEvents();
    this.sticky = this.initStickyModule();
    this.mainSearch = this.createMainSearch();

    this.padContent();
  }

  destroy() {
    this.sticky.destroy();
    this.mainSearch.destroy();
  }

  createMainSearch() {
    console.log("createMainSearch");
    return new MainSearchAuth({
      $el: $(".js-main-search"),
      itemIdPrefix: "main-search"
    });
  }

  handleEvents() {
    this.bindMarkerBoundsOut();
  }

    initStickyModule() {
        return stickyModule({
            $el: null,
            stickyLimit: this.SCROLL_STICKY_BASE,
            enterSticky: () => {
                requestAnimationFrame(() => {
                    if (!this.initialActiveEntry) return;
                });
            },
            leaveSticky: () => {
                if (!this.initialActiveEntry) return;
            }
        });
    }

  bindMarkerBoundsOut() {
    onElementBoundsOut(
      document.querySelector(".dcw_main-nav_list"),
      this.header[0],
      () => {
        if (this.lastActive) {
          return this.marker.translateTo(this.lastActive);
        }

        this.marker.translateAndHide(this.INITIAL_MARKER_POS);
      }
    );

    if (this.secondMarker) {
        onElementBoundsOut(
            this.activeSubList,
            this.activeSubMenu,
            () => {
            if (this.secondActive) {
            return this.secondMarker.translateTo(
                this.secondActive,
                false,
                this.INITIAL_2NDMARKER_POS
            );
        }

        this.secondMarker.translateAndHide(this.INITIAL_2NDMARKER_POS);
        }
        );
    }

    if (this.thirdMarker) {
        onElementBoundsOut(
            this.activeDropDownList,
            this.activeSubMenu,
            () => {
            if (this.thirdActive) {
            return this.thirdMarker.translateTo(
                this.thirdActive,
                false,
                this.INITIAL_3RDMARKER_POS
            );
        }

        this.thirdMarker.translateAndHide(this.INITIAL_3RDMARKER_POS_HIDE);
    }

    );
    }
  }

  getInitialEntry() {
    var initialActiveEntry = this.root.find(".js-menu_item.is-active").eq(0);

    if (!initialActiveEntry.length) {
      let menuItem = this.root.find('a[aria-current="true"]');
      initialActiveEntry = menuItem.length ? menuItem.parent() : null;
    }

    if (initialActiveEntry && initialActiveEntry.length > 0) {
      initialActiveEntry.addClass("is-active");
      return initialActiveEntry;
    }

    return null;
  }

  getSecondEntry() {
    let secondEntry;

    if (!this.initialActiveEntry) return null;

    secondEntry = this.initialActiveEntry.find(".js-submenu_item.is-active");

    if (secondEntry && secondEntry.length > 0) {
        return secondEntry;
    } else {
        return null;
    }
  }

  getThirdEntry() {
        let thirdEntry;

        if (!this.initialActiveEntry) return null;

        thirdEntry = this.initialActiveEntry.find(".js-submenu_elt-in-dropdown .is-active-in-dropdown");
        thirdEntry = thirdEntry.parent();

        if (thirdEntry && thirdEntry.length > 0) {
          return thirdEntry;
        } else {
          return null;
        }
    }


  padContent() {
    var activeSubmenu = this.header.find(
      ".js-menu_item.is-active > .dcw_submenu-auth"
    );

    if (!activeSubmenu.length && this.shouldHaveVisibleTitle()) {
      activeSubmenu = this.header.find(".dcw_submenu-auth--persistent");
    }

    this.padContentBy(this.header.outerHeight() + activeSubmenu.outerHeight());
  }

  padContentBy(value) {
    if(this.isUserTablet()){
        $(".dcw_main").css("margin-top", value + "px");
    }
  }

  createMarkers() {
    return [
      marker("VERTICAL",
          $(".js-marker").eq(0),
          this.menuBarItems,
          96),
      marker(
        "HORIZONTAL",
        $(".js-menu_item.is-active .js-submenu_item").eq(0).find(".js-marker"),
        this.subMenuBarItems
      ),
      marker("HORIZ_Y",
          $(".js-menu_item.is-active .js-dropdown").eq(0).find(".js-marker"),
          this.subMenuBarInDropItems,
          16)
    ];
  }

  shouldHaveVisibleTitle() {
    return (
      $(".dcw_header--no-nav").length ||
      $(".dcw_submenu-auth--persistent").length
    );
  }

  isUserTablet(){
      return $(window).width() < Breakpoint.breakpoint.TABLET;
  }
}


// WEBPACK FOOTER //
// ./src/components/header/HeaderAuth.js